import { XStack } from 'tamagui';
import PSIcon from './ui/PSIcon';
import PSLinkButton from './ui/PSLinkButton';
import { openURL } from '@/src/utils/linkingUtils';

export default function EventLocation({
  venueName,
  googleMapsUrl,
}: {
  venueName: string;
  googleMapsUrl: string;
}) {
  return (
    <XStack items="center" gap={'$space.xs'}>
      <PSIcon name="location-sharp" />
      <PSLinkButton
        variant="neutral"
        title={venueName}
        onPress={() => openURL(googleMapsUrl)}
      />
    </XStack>
  );
}
